export default [
  {
    path: '/entrada/',
    name: 'entrada',
    title: 'entrada',
    component: () => import('../view/EntradaView.vue'),
    redirect: { name: 'entrada-listar' },
    children: [
      {
        path: 'welcome',
        name: 'entrada-listar',
        component: () => import('../view/EntradaWelcomeView.vue'),
        meta: {
          title: 'entrada listar',
        },
      },
      {
        path: 'add',
        name: 'entrada-cadastrar',
        meta: {
          title: 'entrada cadastrar',
        },
        component: () => import('../view/EntradaFormView.vue'),
      },
      {
        path: ':id',
        name: 'entrada-editar',
        meta: {
          title: 'entrada editar',
        },
        component: () => import('../view/EntradaFormView.vue'),
      },
      {
        path: 'manifesto-destinatario',
        name: 'manifesto-destinatario',
        meta: {
          title: 'manifesto destinatário',
        },
        component: () => import('../manifestoDestinatario/EntradaManifestoDestinatarioApp.vue'),
      },
    ],
  },
];
